import type { QuizsetCursorSearchReq } from '@/api/gen/_model/quizsetCursorSearchReq';
import { searchQuizLibrary } from '@/api/gen/quiz/quiz.gen';

import type { LibraryItem } from '../types/library.types';

import { toLibraryItem } from './library.adapters';

export interface LibrarySearchPage {
  items: LibraryItem[];
  nextCursor?: string;
  hasNext: boolean;
  totalCount?: number;
}

/**
 * 서버가 필터로 걸러낸 뒤 빈 페이지를 돌려주는 경우가 있어, 내용이 찰 때까지 커서를 몇 번 더 따라간다.
 * 자료실 퀴즈 전용 검색이 쓰던 규칙을 그대로 옮겼다 — 응답 봉투가 같다.
 */
const MAX_EMPTY_CURSOR_CONTINUATIONS = 3;

export const searchLibrary = async (
  req: QuizsetCursorSearchReq,
  signal?: AbortSignal,
): Promise<LibrarySearchPage> => {
  let response = await searchQuizLibrary(req, undefined, signal);
  const initialTotalCount = response.totalCount;

  for (
    let skippedCount = 0;
    skippedCount < MAX_EMPTY_CURSOR_CONTINUATIONS;
    skippedCount += 1
  ) {
    if (response.data.length > 0 || !response.hasNext || !response.nextCursor) {
      break;
    }
    response = await searchQuizLibrary(
      { ...req, cursor: response.nextCursor },
      undefined,
      signal,
    );
  }

  return {
    items: response.data.map(toLibraryItem),
    nextCursor: response.nextCursor,
    hasNext: response.hasNext,
    totalCount: response.totalCount ?? initialTotalCount,
  };
};
